import { FormControl, FormGroup } from '@angular/forms';
import { NewListaDiagramasService } from '../new-lista-diagramas.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-lista-diagramas-view',
  templateUrl: './new-lista-diagramas-view.component.html',
  styleUrls: ['./new-lista-diagramas-view.component.scss']
})
export class NewListaDiagramasViewComponent implements OnInit {

  diagramas: any = null;
  marcas: any = [];
  loading = true;

  formFiltroListaDiagrama = new FormGroup({
    marca: new FormControl(null)
  });

  constructor(
    private newListaDiagramasService: NewListaDiagramasService
  ) { }

  ngOnInit() {
    this.getAllDiagrams();
  }

  getAllDiagrams() {
    this.loading = true;
    try {
      this.newListaDiagramasService.getAllDiagrams().subscribe((res: any) => {
        if (res.code == 200) {
          //Sucesso
          this.diagramas = res.diagramas.sort(this.compararPorMarca);
          res.diagramas.forEach((diagrama) => {
            this.marcas.push(diagrama.marca);
          });
          this.marcas = this.removerMarcasRepetidas(this.marcas);
          this.diagramas = this.adicionarCheckPrimeiraMarca(this.diagramas);
          this.loading = false;
          return
        } else {
          //Falha
          this.loading = false;
          return
        }
      },
        (error) => {
          //Falha
          this.loading = false;
          return
        });
    } catch (error) {
      //Falha
      this.loading = false;
      return
    }
  }

  adicionarCheckPrimeiraMarca(veiculos) {
    let marcas = {};
    veiculos.forEach((veiculo) => {
      if (typeof veiculo.marca === "string") {
        if (!marcas[veiculo.marca]) {
          marcas[veiculo.marca] = true;
          veiculo.check = true;
        }
      } else if (typeof veiculo.marca === "object") {
        let marca = veiculo.marca.nome || veiculo.marca;
        if (!marcas[marca]) {
          marcas[marca] = true;
          veiculo.check = true;
        }
      }
    });

    return veiculos;
  }

  removerMarcasRepetidas(vetor) {
    const marcasUnicas = {};
    const vetorSemRepeticao = vetor.filter((marca) => {
      if (!marcasUnicas[marca]) {
        marcasUnicas[marca] = true;
        return true;
      }
      return false;
    });

    return vetorSemRepeticao;
  }

  findYearInterval(years) {
    if (!years || years.length === 0) {
      return "";
    }
    if (years.length === 1) {
      return years[0];
    }
    const sortedYears = years.map(Number).sort((a, b) => a - b);
    const startYear = sortedYears[0];
    const endYear = sortedYears[sortedYears.length - 1];
    return `${startYear} até ${endYear}`;
  }

  compararPorMarca(a, b) {
    if (a.marca < b.marca) {
      return -1;
    } else if (a.marca > b.marca) {
      return 1;
    }
    return 0;
  }

  viewMarca(marca: any){
    document.getElementsByClassName(marca)[0].scrollIntoView(true);
  }

}
